import { integrationId, pipelineId } from '../fixture-ids';

const pipelineIntegrationParentRefs = [
  { key: 'pipelineId', entity: 'pipeline' },
  { key: 'integrationId', entity: 'integration' },
];

export const pipelineIntegrationEntries = {
  INTEGRATION_ADDED_TO_PIPELINE: {
    entity: 'pipelineIntegration',
    identity: 'record',
    compositeIdKeys: ['pipelineId', 'integrationId'],
    renderMode: 'diff',
    createsRecord: true,
    parentRefs: pipelineIntegrationParentRefs,
    foreignDisplayKeys: ['pipelineName', 'integrationName'],
  },
  INTEGRATION_REMOVED_FROM_PIPELINE: {
    entity: 'pipelineIntegration',
    identity: 'record',
    compositeIdKeys: ['pipelineId', 'integrationId'],
    renderMode: 'diff',
    createsRecord: false,
    parentRefs: pipelineIntegrationParentRefs,
    foreignDisplayKeys: ['pipelineName', 'integrationName'],
  },
  // Core entry only. The legacy pipelineIntegrationId idKeys alias belongs solely to the legacy
  // alternate: the two generations share no identity key at all (the current trigger never emits
  // the join row's own id).
  PIPELINE_INTEGRATION_UPDATED: {
    entity: 'pipelineIntegration',
    identity: 'record',
    compositeIdKeys: ['pipelineId', 'integrationId'],
    renderMode: 'diff',
    createsRecord: false,
    parentRefs: pipelineIntegrationParentRefs,
    foreignDisplayKeys: ['pipelineName', 'integrationName'],
  },
};

const pipelineIntegrationDebugData = {
  pipelineId,
  pipelineName: 'Web Analytics',
  integrationId,
  integrationName: 'Google Analytics 4',
};

export const pipelineIntegrationFixtures = {
  INTEGRATION_ADDED_TO_PIPELINE: {
    action: 'INTEGRATION_ADDED_TO_PIPELINE',
    debugData: { ...pipelineIntegrationDebugData },
  },
  INTEGRATION_REMOVED_FROM_PIPELINE: {
    action: 'INTEGRATION_REMOVED_FROM_PIPELINE',
    debugData: { ...pipelineIntegrationDebugData },
  },
  PIPELINE_INTEGRATION_UPDATED: {
    action: 'PIPELINE_INTEGRATION_UPDATED',
    debugData: { ...pipelineIntegrationDebugData },
  },
};
